import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';

import { AccountService } from '../services/account.service';
import { Dealer } from '../../shared/models/dealer.interface';
import { FileUpload } from '../../shared/models/file.upload.interface';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent extends AbstractBiditComponent implements OnInit {
  // Maximum file size allowed to
  // be uploaded = 10MB
  MAX_SIZE: number = 10048576;

  dealer: Dealer;
  logoFile: any = null;
  fileBytes: string = '';
  messages: string[] = [];

  constructor(deviceDetectorService: DeviceDetectorService,
    private accountService: AccountService, private router: Router, private route: ActivatedRoute) {
    super(deviceDetectorService);
  }

  ngOnInit() {
    this.refreshData();
  }

  refreshData() {
    this.accountService.getDealer()
      .subscribe({
        next: (data: Dealer) => {
          this.dealer = data;
        },
        error: (error: string) => this.onError(error)
      });
  }

  uploadFile(): void {
    if (this.logoFile == undefined) {
      alert($localize`No file provided`);
      return;
    }

    // Set File Information
    let file: FileUpload = {
      fileName: this.logoFile.name,
      fileSize: this.logoFile.size,
      fileType: this.logoFile.type,
      lastModifiedTime: this.logoFile.lastModified,
      lastModifiedDate: this.logoFile.lastModifiedDate,
    } as FileUpload;

    file.fileAsBase64 = this.fileBytes;

    // POST to server
    this.accountService.saveLogo(file)
      .subscribe({
        next: () => {
          this.messages.push("Upload complete");
          this.dealer = { dealer_Logo: file.fileName } as Dealer;
        },
        error: (error: string) => {
          alert(error);
        }
      });
  }

  deleteLogo() {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    this.accountService.deleteLogo()
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe({
        next: (result: any) => {
          if(result) {
            this.refreshData();
          }
      },
        error: (error: string) => this.onError(error)
      });
  }
}
